import React from 'react';
import Popper, { HintPlacement } from '@zvuk-b2b/react-uikit/ui/Popper';
import { useDetectTextOverflow } from 'application/hooks';

interface EmenuTitleWithTooltipProps extends React.PropsWithChildren {
  title?: string | null;
  testId: string;
  containerClassName: string;
  titleClassName: string;
  popperClassName?: string;
}

const EmenuTitleWithTooltip: React.FC<EmenuTitleWithTooltipProps> = ({
  title,
  testId,
  containerClassName,
  titleClassName,
  popperClassName,
  children,
}) => {
  const { isOverflow, textRef } = useDetectTextOverflow(`[data-testid="${testId}"]`);

  return (
    <div
      ref={textRef}
      className={containerClassName}>
      <Popper
        placement={HintPlacement.PLACEMENT_TOP_START}
        containerClassName={popperClassName}
        isShow={isOverflow}
        offset={[10, 10]}
        triggerNode={
          <span
            data-testid={testId}
            className={titleClassName}>
            {title}
          </span>
        }>
        {title}
      </Popper>
      {children}
    </div>
  );
};

export default EmenuTitleWithTooltip;
